import { Component, Input } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { FilePreviewTypeListMap } from 'src/app/modules/shared/components/file-preview-entry/file-preview-entry.component';
import { TableColumnOption } from 'src/app/modules/shared/components/table-pro/table.config';
import { FileType } from 'src/app/modules/shared/models/form/file-type.enum';
import { FormHeaderFormat } from 'src/app/modules/shared/models/form/form-header-format.enum';
import { FormHeaderListRequest } from 'src/app/modules/shared/models/form/form-header-list-request.model';
import { FormHeaderSearch } from 'src/app/modules/shared/models/form/form-header-search.enum';
import { FormHeaderType } from 'src/app/modules/shared/models/form/form-header-type.enum';
import { FormHeader } from 'src/app/modules/shared/models/form/form-header.model';
import { FormItemType } from 'src/app/modules/shared/models/form/form-item-type.enum';
import { FormItemWidgetType } from 'src/app/modules/shared/models/form/form-item-widget-type.enum';
import { WorkReportDocType } from 'src/app/modules/shared/models/form/work-report-doc-type.enum';
import { WorkReportStatus } from 'src/app/modules/shared/models/form/work-report-status.enum';
import { WorkReport } from 'src/app/modules/shared/models/form/work-report.model';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { OrganizationCategory } from 'src/app/modules/shared/models/staff/organization-category.enum';
import { OrganizationListRequest } from 'src/app/modules/shared/models/staff/organization-list-request.model';
import {
  OrganizationType,
  OrganizationTypeShortMap,
} from 'src/app/modules/shared/models/staff/organization-type.enum';
import { Organization } from 'src/app/modules/shared/models/staff/organization.model';
import { PostListRequest } from 'src/app/modules/shared/models/staff/post-list-request.model';
import { UserListRequest } from 'src/app/modules/shared/models/staff/user-list-request.model';
import { UserPost } from 'src/app/modules/shared/models/staff/user-post.model';
import { User } from 'src/app/modules/shared/models/staff/user.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { OmFormHeaderService } from 'src/app/modules/shared/services/om-form-header.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { StaffOrganizationService } from 'src/app/modules/shared/services/staff-organization.service';
import { WorkReportService } from 'src/app/modules/shared/services/work-report.service';
import { environment } from 'src/environments/environment';
import { StaffPostService } from './../../../../shared/services/staff-post.service';
import { StaffUserService } from './../../../../shared/services/staff-user.service';

interface ZhusongSelection {
  constructionSectionId?: number;
  superviseSectionId?: number;
  locatedSectionId?: number;
  orgId?: number;
  orgName?: string;
}

interface MatchedSigner {
  user: User;
  orgId?: number;
  sectionId?: number;
  post?: UserPost;
}

@Component({
  selector: 'app-custom-menu-form-fill-dialog',
  templateUrl: './custom-menu-form-fill-dialog.component.html',
  styleUrls: ['./custom-menu-form-fill-dialog.component.scss'],
})
export class CustomMenuFormFillDialogComponent {
  @Input()
  data!: DialogConfig<WorkReport>;

  editing: { [name: string]: boolean } = {};

  record: WorkReport = new WorkReport();

  fileUrls: string[] = [];

  consSectionList: ProjectSection[] = [];

  supSectionList: ProjectSection[] = [];

  optionMap: { [key: string]: TableColumnOption[] } = {};

  headerList: FormHeader[] = [];

  headerMap: { [key: string]: FormHeader } = {};

  FormHeaderFormat = FormHeaderFormat;

  supOrgNameList: string[] = [];
  consOrgNameList: string[] = [];

  FilePreviewTypeListMap = FilePreviewTypeListMap;
  FileType = FileType;
  FormHeaderSearch = FormHeaderSearch;
  // transformableImageElementRef!: TransformableElement;

  currentFileId = '';

  currentFileType = FileType.PDF;

  environment = environment;

  get withToken() {
    return '?token=' + this.globalService.token;
  }

  height = 0;
  width = 0;
  // index = 0;

  pdfZoom = 1;
  pdfPages = 1;
  pdfTotal = 0;

  WorkReportDocType = WorkReportDocType;

  loading: any;

  freeHeaderFormItemIds: number[] = [];
  freeHeaderFormItemMap: { [key: string]: string } = {};

  requireMap: { [key: string]: boolean } = {};

  oneday = 24 * 60 * 60 * 1000;

  hasZhusong = false;

  // zhusongOrgList: string[] = [];

  prOrgList: TableColumnOption[] = [];

  signPostUsers: User[] = [];

  WorkReportStatus = WorkReportStatus;

  zhusongOrgId: string = '';

  constructor(
    private globalService: GlobalService,
    private omFormHeaderService: OmFormHeaderService,
    private workReportService: WorkReportService,
    private projectSectionService: ProjectSectionService,
    private staffOrganizationService: StaffOrganizationService,
    private staffPostService: StaffPostService,
    private staffUserService: StaffUserService,
  ) {}

  private getTargetOrgTypeByWorkReportName(): OrganizationType | undefined {
    const reportName = `${this.record?.name ?? ''}`.trim();
    if (!reportName) {
      return undefined;
    }

    const shortName = reportName
      .split('-')
      .map((item) => item.trim())
      .filter((item) => !!item)
      .pop();
    if (!shortName) {
      return undefined;
    }

    for (const type of Object.keys(OrganizationTypeShortMap)) {
      if (OrganizationTypeShortMap[type as OrganizationType] === shortName) {
        return type as OrganizationType;
      }
    }

    return undefined;
  }

  private shouldIncludeOrgType(
    targetOrgType: OrganizationType | undefined,
    orgType: OrganizationType | undefined,
  ) {
    if (!targetOrgType) {
      return true;
    }
    return orgType === targetOrgType;
  }

  isDateValid(dateStr: string): boolean {
    return !isNaN(new Date(dateStr).getTime());
  }

  private prepare() {
    zip(
      this.projectSectionService.findAll({
        projectId: this.globalService.projectId,
      }),
      this.staffOrganizationService.findAll<OrganizationListRequest>({
        projectId: this.globalService.projectId,
      }),
      this.omFormHeaderService.findAll<FormHeaderListRequest>({
        formId: this.record.formId,
      }),
      this.staffPostService.findAll<PostListRequest>({
        projectId: this.globalService.projectId,
        name: '文件签收人',
      }),
    ).subscribe(([sectionList, orgList, headers, posts]) => {
      this.consSectionList = [];
      this.supSectionList = [];
      for (const section of sectionList) {
        if (section.type === OrganizationType.SUPERVISE) {
          this.supSectionList.push(section);
        }
        if (section.type === OrganizationType.CONSTRUCTION) {
          this.consSectionList.push(section);
        }
      }
      for (const org of orgList) {
        if (org.type === OrganizationType.SUPERVISE) {
          this.supOrgNameList.push(org.name!);
        }
        if (org.type === OrganizationType.CONSTRUCTION) {
          this.consOrgNameList.push(org.name!);
        }
      }

      // 获取文件签收人用户
      if (posts.length > 0) {
        this.staffUserService
          .findAll<UserListRequest>({
            projectId: this.globalService.projectId,
            postId: posts[0].id!,
          })
          .subscribe((res: User[]) => {
            this.signPostUsers = res;
            console.log('文件签收人', this.signPostUsers);
          });
      }

      const obj$: Observable<string[]>[] = [];
      const optKeys: string[] = [];
      const headersMap: { [key: string]: FormHeader } = {};
      const headerList: FormHeader[] = [];
      console.log(headers);
      for (const header of headers) {
        headersMap[header.fieldName!] = header;
        if (header.type === FormHeaderType.FREE && !header.hidden) {
          this.freeHeaderFormItemIds.push(header.formItemId!);
          this.freeHeaderFormItemMap[header.formItemId!] = header.fieldName!;
        }
        if (
          header.hidden ||
          !header.headerName ||
          header.fieldName === 'sectionId' ||
          header.fieldName === 'superviseSectionId' ||
          header.fieldName === 'constructionOrgName' ||
          header.fieldName === 'supervisionOrgName'
        ) {
          continue;
        }
        if (header.type === FormHeaderType.FREE && !header.formItemId) {
          continue;
        }
        headerList.push(header);
        if (
          header.type === FormHeaderType.FREE &&
          header.headerName === '主送单位'
        ) {
          this.hasZhusong = true;
          const prOrgList: TableColumnOption[] = [];
          const sectionIds: number[] = [];
          const targetOrgType = this.getTargetOrgTypeByWorkReportName();
          for (const section of this.globalService.userInfo.projectSections ??
            []) {
            if (section.sectionType === OrganizationType.CONSTRUCTION) {
              sectionIds.push(section.sectionId!);
            }
          }
          for (const section of sectionList) {
            if (sectionIds.includes(section.id!)) {
              let supSectionId = undefined;
              for (const ref of section.projectSectionSections ?? []) {
                if (ref.refSectionType === OrganizationType.SUPERVISE) {
                  supSectionId = ref.refSectionId;
                  break;
                }
              }
              for (const org of section.projectSectionOrganizations ?? []) {
                if (
                  this.shouldIncludeOrgType(targetOrgType, org.organizationType)
                ) {
                  // value结构为“施工标段id#监理标段id#所在标段id#单位id#单位名称”，用于后续解析回填和流程生成
                  prOrgList.push({
                    value: `${section.id}#${supSectionId}#${org.sectionId}#${org.organizationId}#${org.organizationName}`,
                    label: `${section.name}/${org.organizationName}`,
                  });
                }
              }

              for (const refSections of section.projectSectionSections ?? []) {
                for (const org of refSections.refSectionOrganizations ?? []) {
                  const orgType =
                    org.organizationType ?? refSections.refSectionType;
                  if (!this.shouldIncludeOrgType(targetOrgType, orgType)) {
                    continue;
                  }
                  // value结构为“施工标段id#监理标段id#所在标段id#单位id#单位名称”，用于后续解析回填和流程生成
                  prOrgList.push({
                    value: `${section.id}#${supSectionId}#${org.sectionId}#${org.organizationId}#${org.organizationName}`,
                    label: `${org.sectionName}/${org.organizationName}`,
                  });
                }
              }
            }
          }

          for (const org of orgList.filter(
            (item) => item.category === OrganizationCategory.COMPANY,
          )) {
            // TODO: 标记需要根据用户所在标段关联的单位（projectSectionDlOrganizations）进行判断，哪些建设单位是当前用户所在标段的代建单位

            if (
              org.type === OrganizationType.DEVELOPMENT &&
              this.shouldIncludeOrgType(targetOrgType, org.type)
            ) {
              prOrgList.push({
                value: `${-1}#${-1}#${-1}#${org.id}#${org.name}`,
                label: `建设单位/${org.name}`,
              });
            }
          }

          // for (const org of orgList) {
          //   if (
          //     org.type === OrganizationType.CONSTRUCTION &&
          //     org.category === OrganizationCategory.INSTITUTION
          //   ) {
          //     for (const section of sectionList) {
          //       if (sectionIds.includes(section.id!)) {
          //         let supSectionId = undefined;
          //         for (const ref of section.projectSectionSections ?? []) {
          //           if (ref.refSectionType === OrganizationType.SUPERVISE) {
          //             supSectionId = ref.refSectionId;
          //             break;
          //           }
          //         }
          //         if (supSectionId) {
          //           prOrgList.push({
          //             value: `${org.sectionId}#${org.name}#${supSectionId}`,
          //             label: `${section.name}/${org.name}`,
          //           });
          //         }
          //       }
          //     }
          //   }
          // }
          // prOrgList通过label去重
          const uniquePrOrgList = prOrgList.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.label === item.label),
          );
          this.prOrgList = uniquePrOrgList;
          if (this.prOrgList.length === 1) {
            this.zhusongOrgId = this.prOrgList[0].value as string;
            if (this.record.status !== WorkReportStatus.FINISH) {
              this.record[header.fieldName!] = this.zhusongOrgId;
            }
            // setTimeout(() => {
            //   this.onZhusongChange();
            // }, 1000);
          }
          // if (
          //   this.record[header.fieldName!] &&
          //   this.record.sectionId &&
          //   this.record.superviseSectionId
          // ) {
          //   this.zhusongOrgId = `${this.record.sectionId}#${
          //     this.record[header.fieldName!]
          //   }#${this.record.superviseSectionId}`;
          // }
          // console.log('zhusong id', this.zhusongOrgId);
        }
        if (header.search === FormHeaderSearch.ENUM) {
          obj$.push(
            this.workReportService.listEnumValues({
              fieldName: header.fieldName!,
              menuId: this.record.menuId!,
              projectId: this.globalService.projectId,
            }),
          );
          optKeys.push(header.fieldName!);
        }
        if (!!header.fixedParamValue) {
          this.record[header.fieldName!] = header.fixedParamValue;
        }
        if (header.headerName === '归属年月') {
          try {
            if (this.isDateValid(this.record[header.fieldName!])) {
              const d = new Date(this.record[header.fieldName!]);
              this.record[header.fieldName!] = d;
            } else {
              this.record[header.fieldName!] = new Date();
            }
          } catch (e) {
            this.record[header.fieldName!] = new Date();
          }
        }
      }
      this.headerList = headerList;
      this.headerMap = headersMap;
      console.log(this.freeHeaderFormItemIds);
      for (const item of this.record.form?.formItems ?? []) {
        if (
          ((item.musted && item.type === FormItemType.VARIABLES) ||
            item.type === FormItemType.CONSTANT) &&
          this.freeHeaderFormItemIds.includes(item.id!)
        ) {
          this.requireMap[item.id!] = true;
        }
      }
      console.log(this.requireMap);

      zip(...obj$).subscribe((res: string[][]) => {
        for (let i = 0; i < res.length; i++) {
          const opts: TableColumnOption[] = [];
          for (const item of res[i]) {
            opts.push({
              label: item,
              value: item,
            });
          }
          this.optionMap[optKeys[i]] = opts;
        }
      });
      this.autoFill();
    });
  }

  ngOnInit() {
    this.record = this.handleDataBeforeInit(this.data.data!);
    if (this.record.status === WorkReportStatus.FINISH) {
      this.workReportService
        .findById(this.record.id!)
        .subscribe((response: WorkReport) => {
          this.record = response;
          console.log(response);
          this.handleFiles();
          this.prepare();
        });
    } else {
      this.handleFiles();
      this.prepare();
    }
  }

  onZhusongChange() {
    console.log('onZhusongChange:', this.record);
    if (!this.zhusongOrgId) return;
    for (const header of this.headerList) {
      if (header.headerName === '主送单位') {
        this.record[header.fieldName!] = this.zhusongOrgId;
        break;
      }
    }
    const data = this.parseZhusongSelection(this.zhusongOrgId);
    if (data) {
      this.record.sectionId = +data.constructionSectionId!;
      this.record.constructionOrgName = data.orgName;
      this.record.superviseSectionId = +data.superviseSectionId!;
    }
    console.log('onZhusongChange:', this.record);
  }

  private autoFill() {
    // 如果我是监理单位，那么我只能选择监理单位
    // 如果我是施工单位，那么我选择施工单位，然后选择标段，最后选择监理单位
    if (
      this.globalService.userInfo.organizationType ===
        OrganizationType.SUPERVISE &&
      !this.record.supervisionOrgName
    ) {
      this.record.supervisionOrgName =
        this.globalService.userInfo.organizationName;
    }
    if (
      this.globalService.userInfo.organizationType ===
        OrganizationType.CONSTRUCTION &&
      !this.record.constructionOrgName
    ) {
      this.record.constructionOrgName =
        this.globalService.userInfo.organizationName;
      this.record.sectionId =
        this.globalService.userInfo.projectSections &&
        this.globalService.userInfo.projectSections[0].sectionId
          ? this.globalService.userInfo.projectSections[0].sectionId
          : undefined;
      if (this.record.sectionId) {
        this.staffOrganizationService
          .findAll<OrganizationListRequest>({
            projectId: this.globalService.projectId,
            projectSections: this.globalService.userInfo.projectSections,
            type: OrganizationType.SUPERVISE,
          })
          .subscribe((orgList: Organization[]) => {
            if (orgList.length > 0) {
              this.record.supervisionOrgName = orgList[0].name;
            }
          });
      }
    }
    const cache = this.globalService.getFormCodeFillHistory(this.record.code!);
    if (!!cache) {
      for (const header of this.headerList) {
        if (
          header.hidden ||
          !header.headerName ||
          header.fieldName === 'sectionId' ||
          header.fieldName === 'constructionOrgName' ||
          header.fieldName === 'supervisionOrgName' ||
          header.fieldName === 'sn'
        ) {
          continue;
        }
        // if (
        //   header.format === FormHeaderFormat.DATE &&
        //   !this.record[header.fieldName!] &&
        //   this.record[header.fieldName!] !== '-' &&
        //   cache[header.fieldName!] !== '-' &&
        //   !!cache[header.fieldName!]
        // ) {
        //   try {
        //     const d = new Date(cache[header.fieldName!]);
        //     this.record[header.fieldName!] = new Date(
        //       d.getTime() + this.oneday
        //     );
        //   } catch (e) {}
        // }
        // if (
        //   header.format !== FormHeaderFormat.DATE &&
        //   !!cache[header.fieldName!] &&
        //   this.record[header.fieldName!] !== '-' &&
        //   !this.record[header.fieldName!]
        // ) {
        //   this.record[header.fieldName!] = cache[header.fieldName!];
        // }
      }
    }
    for (const table of this.record.form?.formData ?? []) {
      for (const row of table.rows ?? []) {
        for (const cell of row.columns ?? []) {
          if (
            !!cell.formItem?.id &&
            this.freeHeaderFormItemIds.includes(cell.formItem.id) &&
            !!this.freeHeaderFormItemMap[cell.formItem.id] &&
            !!cell.value &&
            cell.formItem.widget !== FormItemWidgetType.DATE
          ) {
            if (!this.record[this.freeHeaderFormItemMap[cell.formItem.id]]) {
              this.record[this.freeHeaderFormItemMap[cell.formItem.id]] =
                cell.value;
            }
          }
        }
      }
    }
  }

  private handleFiles() {
    try {
      if (this.record.pdfFiles) {
        this.record.pdfFilesList = JSON.parse(this.record.pdfFiles);
      }
    } catch (e) {
      console.log(e);
    }
    try {
      if (this.record.signHalfFiles) {
        this.record.signHalfFilesList = JSON.parse(this.record.signHalfFiles);
      }
    } catch (e) {
      console.log(e);
    }
    try {
      if (this.record.signFiles) {
        this.record.signFilesList = JSON.parse(this.record.signFiles);
      }
    } catch (e) {
      console.log(e);
    }
    if (this.record.docType === WorkReportDocType.PDF_SIGNED) {
      this.record.docPdfId = this.record.signFilesList![0];
    } else {
      if (this.record.signFilesList && this.record.signFilesList.length > 0) {
        this.record.docPdfId = this.record.signFilesList![0];
      } else if (
        this.record.signHalfFilesList &&
        this.record.signHalfFilesList.length > 0
      ) {
        this.record.docPdfId = this.record.signHalfFilesList![0];
      } else {
        this.record.docPdfId = this.record.pdfFilesList![0];
      }
    }
    this.currentFileId = this.record.docPdfId ?? '';
  }

  chooseMain() {
    this.currentFileId = this.record.docPdfId!;
    this.currentFileType = FileType.PDF;
  }

  chooseAttach(index: number) {
    console.log(index);
    this.currentFileId = this.record.attachs![index].fileId!;
    this.currentFileType = this.record.attachs![index].fileType!;
  }

  ngAfterViewInit(): void {
    window.addEventListener('resize', () => {
      this.resize();
    });
    setTimeout(() => {
      this.resize();
    }, 50);
  }

  resize() {
    this.height = document.body.clientHeight;
    this.width =
      this.record.attachs && this.record.attachs.length > 0
        ? document.body.clientWidth - 910
        : document.body.clientWidth - 610;
  }

  onPageLoad(event: any) {
    console.log(event);
    // this.loading.loadingInstance.close();
    this.pdfTotal = event.source.pdfDocument._pdfInfo.numPages;
    this.resize();
  }

  prePage() {
    if (this.pdfPages > 1) {
      this.pdfPages--;
    }
  }

  nextPage() {
    if (this.pdfPages < this.pdfTotal) {
      this.pdfPages++;
    }
  }

  originSize() {
    this.pdfZoom = 1;
  }

  zoomIn() {
    this.pdfZoom += 0.1;
    if (this.pdfZoom > 2) {
      this.pdfZoom = 2;
    }
  }

  zoomOut() {
    this.pdfZoom -= 0.1;
    if (this.pdfZoom < 0.5) {
      this.pdfZoom = 0.5;
    }
  }

  onBlur() {
    this.editing = {};
  }

  private handleDataBeforeInit(response: WorkReport): WorkReport {
    const data = JSON.parse(JSON.stringify(response)) as WorkReport;
    return data;
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    if (this.record.status !== WorkReportStatus.FINISH) {
      const result = this.handleDataBeforeConfirm(this.record);
      this.data.onConfirm!(result);
    } else {
      this.submit();
    }
  }

  // 解析主送单位选项值，提取施工标段、监理标段、所在标段、单位ID和单位名称。
  // 输入为 nz-select 的 value 原始字符串；解析失败时返回 undefined。
  private parseZhusongSelection(value: string): ZhusongSelection | undefined {
    const parts = value.split('#');

    return {
      constructionSectionId: +parts[0],
      superviseSectionId: +parts[1],
      locatedSectionId: +parts[2],
      orgId: +parts[3],
      orgName: parts[4],
    };
  }

  // 对标段ID集合做标准化处理：过滤 undefined/NaN/-1 并按出现顺序去重。
  // 返回可直接用于 sectionId/superviseSectionId 回填的干净数组。
  private uniqueValidSectionIds(ids: Array<number | undefined>): number[] {
    const unique: number[] = [];
    for (const id of ids) {
      if (
        typeof id === 'number' &&
        Number.isFinite(id) &&
        id !== -1 &&
        !unique.includes(id)
      ) {
        unique.push(id);
      }
    }
    return unique;
  }

  // 将去重后的标段ID回填到单值或多值字段。
  // values 长度为 1 时写入 singleKey；大于 1 时写入 multiKey；为空时不覆盖原值。
  private applySectionField(
    data: WorkReport,
    singleKey: string,
    multiKey: string,
    values: number[],
  ) {
    if (values.length === 0) {
      return;
    }
    if (values.length === 1) {
      data[singleKey] = values[0];
      data[multiKey] = undefined;
      return;
    }
    data[singleKey] = undefined;
    data[multiKey] = values;
  }

  // 从当前已加载的标段中收集与 sourceSectionId 关联的目标类型标段ID。
  // 同时兼容正向关联和反向关联，避免因配置方向不同导致漏填。
  private findRelatedSectionIdsByType(
    sourceSectionId: number,
    targetType: OrganizationType,
  ): number[] {
    const allSections = [...this.consSectionList, ...this.supSectionList];
    const result: number[] = [];

    const sourceSection = allSections.find(
      (item) => item.id === sourceSectionId,
    );
    if (sourceSection) {
      for (const ref of sourceSection.projectSectionSections ?? []) {
        if (
          ref.refSectionType === targetType &&
          typeof ref.refSectionId === 'number'
        ) {
          result.push(ref.refSectionId);
        }
      }
    }

    for (const section of allSections) {
      if (section.type !== targetType) {
        continue;
      }
      for (const ref of section.projectSectionSections ?? []) {
        if (
          ref.refSectionId === sourceSectionId &&
          typeof section.id === 'number'
        ) {
          result.push(section.id);
        }
      }
    }

    return this.uniqueValidSectionIds(result);
  }

  private handleDataBeforeConfirm(response: WorkReport): WorkReport {
    const data = JSON.parse(JSON.stringify(response)) as WorkReport;

    for (const header of this.headerList) {
      if (header.hidden) {
        continue;
      }
      if (
        header.type === FormHeaderType.FREE &&
        header.headerName === '主送单位'
      ) {
        const selection = this.parseZhusongSelection(this.zhusongOrgId);
        if (selection?.orgName) {
          data[header.fieldName!] = selection.orgName;
        }

        const constructionId = selection?.constructionSectionId;
        const superviseId = selection?.superviseSectionId;
        const locatedId = selection?.locatedSectionId;

        let sectionIds: number[] = [];
        let superviseSectionIds: number[] = [];

        // 3: 没有所在标段，清空标段字段。
        if (locatedId === -1 || typeof locatedId !== 'number') {
          data.sectionId = undefined;
          data.sectionIds = undefined;
          data.superviseSectionId = undefined;
          data.superviseSectionIds = undefined;
        } else {
          // 1: 所在标段是施工标段。
          if (locatedId === constructionId) {
            sectionIds = this.uniqueValidSectionIds([constructionId]);
            superviseSectionIds = this.uniqueValidSectionIds([superviseId]);
          }

          // 2: 所在标段是监理标段。
          else if (locatedId === superviseId) {
            superviseSectionIds = this.uniqueValidSectionIds([superviseId]);
            sectionIds = this.uniqueValidSectionIds([
              constructionId,
              ...this.findRelatedSectionIdsByType(
                locatedId,
                OrganizationType.CONSTRUCTION,
              ),
            ]);
          }

          // 4: 所在标段既不是施工也不是监理，按关联关系反查。
          else {
            sectionIds = this.uniqueValidSectionIds([
              ...this.findRelatedSectionIdsByType(
                locatedId,
                OrganizationType.CONSTRUCTION,
              ),
            ]);
            superviseSectionIds = this.uniqueValidSectionIds([
              ...this.findRelatedSectionIdsByType(
                locatedId,
                OrganizationType.SUPERVISE,
              ),
            ]);
          }

          this.applySectionField(data, 'sectionId', 'sectionIds', sectionIds);
          this.applySectionField(
            data,
            'superviseSectionId',
            'superviseSectionIds',
            superviseSectionIds,
          );
        }
      }
      if (
        header.format === FormHeaderFormat.DATE &&
        data[header.fieldName!] !== '-' &&
        !!data[header.fieldName!]
      ) {
        const d = new Date(data[header.fieldName!]);
        data[header.fieldName!] = `${d.getFullYear()}-${(d.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
      }
      if (
        header.headerName === '归属年月' &&
        data[header.fieldName!] !== '-' &&
        !!data[header.fieldName!]
      ) {
        const d = new Date(data[header.fieldName!]);
        data[header.fieldName!] = `${d.getFullYear()}-${(d.getMonth() + 1)
          .toString()
          .padStart(2, '0')}`;
      }
    }
    for (const table of data.form?.formData ?? []) {
      for (const row of table.rows ?? []) {
        for (const cell of row.columns ?? []) {
          if (cell.formItem?.widget === FormItemWidgetType.CODE && !!data.sn) {
            cell.value = data.sn ?? '';
          }
        }
      }
    }
    const cache: any = {};
    for (const header of this.headerList) {
      if (
        header.hidden ||
        !header.headerName ||
        header.fieldName === 'sectionId' ||
        header.fieldName === 'constructionOrgName' ||
        header.fieldName === 'supervisionOrgName' ||
        header.fieldName === 'sn'
      ) {
        continue;
      }
      if (!!data[header.fieldName!]) {
        cache[header.fieldName!] = data[header.fieldName!];
      }
    }
    this.globalService.setFormCodeFillHistory(data.code!, cache);
    if (`${data.superviseSectionId}` === '-1') {
      data.superviseSectionId = undefined;
    }
    if (`${data.sectionId}` === '-1') {
      data.sectionId = undefined;
    }
    return data;
  }

  get canConfirm() {
    for (const header of this.headerList) {
      if (
        !this.record[header.fieldName!] &&
        this.requireMap[header.formItemId!]
      ) {
        return false;
      }
    }

    if (
      this.record.status !== WorkReportStatus.FINISH &&
      this.hasZhusong &&
      !this.zhusongOrgId
    ) {
      return false;
    }
    return true;
  }

  private submit() {
    const record = this.handleDataBeforeConfirm(this.record);
    this.workReportService
      .addingContent(record)
      .subscribe((response: boolean) => {
        if (response) {
          this.data.onConfirm!(record);
        }
      });
  }
}
